import { computed, ref } from 'vue'
import { useInfiniteScroll, useTitle } from '@vueuse/core'
import { useRoute } from 'vue-router/composables'
import type { RankingPageConfig } from '../configs/types'
import { api } from '@/api'

export function useRanking(columnId: string, config: RankingPageConfig) {
  const route = useRoute()
  const books = ref<any>({})
  const titleValue = computed(() => {
    const t = route.query?.title
    if (Array.isArray(t))
      return t[0] || 'column'
    return t || 'column'
  })
  const title = useTitle(titleValue.value)
  const collections = ref<any>([])
  const page = ref(1)
  const fetching = ref(false)
  const ending = ref(false)
  const error = ref<any>()
  const pagination = computed(() => ({
    pageIndex: page.value,
    pageSize: 10,
  }))

  const getCollectionByType = async function () {
    const result = await api.get('/content/getColumnContentList', { params: { columnId, ...pagination.value } })
    return result.data
  }

  async function fetchCollection() {
    fetching.value = true
    try {
      const data = await getCollectionByType()
      collections.value = [...collections.value, ...data.resourceList.records]
      title.value = data.showName || titleValue.value
      books.value = data
      if (page.value >= data.resourceList.pages)
        ending.value = true
      else
        page.value += 1
    }
    catch (_error) {
      error.value = _error
    }
    finally {
      fetching.value = false
    }
  }

  const infiniteRef = ref<HTMLElement>()
  useInfiniteScroll(infiniteRef,
    async () => {
      if (fetching.value || ending.value || error.value)
        return
      await fetchCollection()
    },
    { distance: 50 },
  )

  const homeBgUrl = config.resources.homeBg ? `url(${config.resources.homeBg})` : 'none'
  const rankGradient = config.theme.rankGradient

  return {
    title,
    books,
    collections,
    fetching,
    ending,
    infiniteRef,
    homeBgUrl,
    rankGradient,
  }
}
